export default __webpack_public_path__ + "images/A5.c3edf12.png";